import axios from "axios"
import { _throw } from "../utils/error-service"
import { API, BASIC_AUTH } from '../constants/system'

export const api_get_merchant = async (token, id) => {
  try {
    const res = await axios.get(`${API}/merchant/${id}`, {
      headers: {
        'Authorization': token ? token : BASIC_AUTH
      }
    })
    return res.data
  } catch (err) {
    return _throw(err)
  }
}

export const api_get_merchants = async (token) => {
  try {
    const res = await axios.get(`${API}/cms/merchants`, {
      headers: {
        'Authorization': token 
      }
    })
    return res.data
  } catch (err) {
    return _throw(err)
  }
}

export const api_get_merchant_storefront = async (token, id) => {
  try {
    const res = await axios.get(`${API}/cms/storefront/${id}`, {
      headers: {
        'Authorization': token
      }
    })
    return res.data
  } catch (err) {
    return _throw(err)
  }
}

export const api_update_merchant_storefront = async (data, token, id) => {
  try {
    const res = await axios.put(`${API}/cms/storefront/${id}`, data, {
      headers: {
        'Authorization': token
      }
    })
    return res.data
  } catch (err) {
    return _throw(err)
  }
}

export const api_update_merchant_location = async (data, token, id) => {
  try {
    const res = await axios.put(`${API}/cms/merchant/${id}/update-location`, data, {
      headers: {
        'Authorization': token
      }
    })
    return res.data
  } catch (err) {
    return _throw(err)
  }
}


export const api_pause_orders = async (token, id) => {
  try {
    const res = await axios.put(`${API}/cms/pause-orders/${id}`, {}, {
      headers: {
        'Authorization': token
      }
    })
    return res.data
  } catch (err) {
    return _throw(err)
  }
}

export const api_resume_orders = async (token, id) => {
  try {
    const res = await axios.put(`${API}/cms/resume-orders/${id}`, {}, {
      headers: {
        'Authorization': token
      }
    })
    return res.data
  } catch (err) {
    return _throw(err)
  }
}


export const api_get_merchant_logs = async (token, id) => {
  try {
    const res = await axios.get(`${API}/cms/merchant/${id}/logs`, {
      headers: {
        'Authorization': token
      }
    })
    return res.data
  } catch (err) {
    return _throw(err)
  }
}

export const api_get_delivery_zones = async (token, id) => {
  try {
    const res = await axios.get(`${API}/cms/merchant-delivery-zones/${id}`, {
      headers: {
        'Authorization': token
      }
    })
    return res.data
  } catch (err) {
    return _throw(err)
  }
}

export const api_get_all_delivery_zones = async (token) => {
  try {
    const res = await axios.get(`${API}/cms/delivery-zones`, {
      headers: {
        'Authorization': token
      }
    })
    return res.data
  } catch (err) {
    return _throw(err)
  }
}

export const api_add_delivery_zone = async (token, data) => {
  try {
    const res = await axios.post(`${API}/cms/delivery-zone`, data, {
      headers: {
        'Authorization': token
      }
    })
    return res.data
  } catch (err) {
    return _throw(err)
  }
}

export const api_remove_delivery_zone = async (token, id) => {
  try {
    const res = await axios.delete(`${API}/cms/delivery-zone/${id}`, {
      headers: {
        'Authorization': token
      }
    })
    return res.data
  } catch (err) {
    return _throw(err)
  }
}

export const api_update_delivery_zone = async (token, id, minOrderSize) => {
  try {
    const res = await axios.put(`${API}/cms/delivery-zone/${id}`, {
      minOrderSize,
      name: ""
    }, {
      headers: {
        'Authorization': token
      }
    })
    return res.data
  } catch (err) {
    return _throw(err)
  }
}